$(window).on('load', () => {
  // AOS.init({
  //   offset: jQuery(window).height() * 0.1,
  // });
  // const header = document.querySelector('header');

  // window.addEventListener('scroll', function (e) {
  //   let scrollPosition = window.scrollY;
  //   if (+scrollPosition > 40) {
  //     if (!header.classList.contains('scrolled')) {
  //       header.classList.add('scrolled');
  //     }
  //   } else {
  //     header.classList.remove('scrolled');
  //   }
  // });
});
